import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
	{
		path: '/',
		component: ()=> import('@/views/dashboard/index.vue'),
		hidden: true
	},{ 
		path: '/nofound', 
		component: () => import('@/views/error/nofound.vue'),
		hidden: true 
	},{ 
		path: '/:catchAll(.*)', 
		redirect: '/nofound',
		hidden: true 
	}
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
